import styled from "styled-components";

export const PorfolioContainer = styled.div`
  border-radius: 12px;
  background: var(--Neutral-950, #141518);
  padding: 16px;
  .list-token {
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
  }
  .item-token {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    width: calc(100% / 4 - 24px);
  }
  .block-token {
    position: relative;
    .icon-token {
      img {
        border-radius: 50%;
        overflow: hidden;
      }
    }
    .icon-chain {
      position: absolute;
      top: -3px;
      left: -4px;
      z-index: 1;
    }
  }
  .name-token {
    margin-bottom: 6px;
    .sysbol {
      color: var(--Neutral-50, #f7f7f8);
      font-family: DMMono-500;
      font-size: 14px;
      line-height: 16px; /* 114.286% */
      margin-right: 6px;
    }
    .name {
      color: var(--Neutral-400, #92929e);
      font-family: DMMono-400;
      font-size: 12px;
      line-height: 16px; /* 133.333% */
    }
  }
  .amount-token {
    margin-bottom: 6px;
    .amount {
      color: var(--Neutral-50, #f7f7f8);
      font-family: DMMono-500;
      font-size: 12px;
      line-height: 16px; /* 133.333% */
      margin-right: 6px;
    }
    .percent {
      color: var(--trionn-com-red, #eb0000);
      font-family: DMMono-400;
      font-size: 12px;
      line-height: 16px; /* 133.333% */
    }
  }
  .price-token {
    margin-bottom: 6px;
    .usd-price {
      color: var(--Neutral-50, #f7f7f8);
      font-family: DMMono-500;
      font-size: 12px;
      line-height: 16px; /* 133.333% */
      margin-right: 6px;
    }
    .eth-value {
      color: var(--Neutral-400, #92929e);
      font-family: DMMono-400;
      font-size: 12px;
      line-height: 16px; /* 133.333% */
    }
  }
  .address-token {
    display: flex;
    align-items: center;
    gap: 6px;
    .address {
      color: var(--Neutral-100, #eeeef0);
      text-align: center;
      font-family: DMMono-400;
      font-size: 12px;
      line-height: 12px; /* 100% */
    }
    .action {
      display: flex;
      gap: 6px;
    }
    .copy,
    .arrow {
      border-radius: 4px;
      background: rgba(40, 39, 44, 0.6);
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
  .unfold-button {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ff394a;
    text-align: center;
    font-family: Syne;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%; /* 17.5px */
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    cursor: pointer;
    &:hover {
      text-decoration: none;
    }
  }
  &.light {
    background-color: #fff;
    border: solid 1px rgb(184, 184, 193);
    .name-token {
      .sysbol {
        color: var(--Neutral-900, #3a3a40);
      }
      .name {
        color: var(--Neutral-400, #92929e);
      }
    }
    .amount-token {
      .amount {
        color: var(--Neutral-900, #3a3a40);
      }
    }
    .price-token {
      .usd-price {
        color: var(--Neutral-900, #3a3a40);
      }
      .eth-value {
        color: var(--Neutral-400, #92929e);
      }
    }
    .address-token {
      .address {
        color: var(--Neutral-800, #43424a);
      }
      .copy,
      .arrow {
        background: rgba(238, 238, 240, 0.6);
      }
    }
  }
  @media screen and (max-width: 768px) {
    padding: 10px;
    .list-token {
      gap: 10px;
      justify-content: space-between;
      .item-token {
        width: calc(100% / 2 - 10px);
        gap: 6px;
        margin-bottom: 12px;
      }
    }
    .icon-token {
      width: 22px;
      height: 22px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .address-token {
      display: block;
      .address {
        margin-bottom: 6px;
        display: inline-block;
      }
    }
  }
  .unfold-button {
    width: calc(100% / 4 - 24px);
  }
`;
